import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { ImageResultData } from '@hiptraveler/data-access/api';

@Injectable()
export class InformationService {

  @Select(ItineraryState.imageInformation) imageInformation$: Observable<ImageResultData>;

}
